import { render, staticRenderFns } from "./otherGoodsInfoModules.vue?vue&type=template&id=fa883d06&scoped=true&"
import script from "./otherGoodsInfoModules.vue?vue&type=script&lang=js&"
export * from "./otherGoodsInfoModules.vue?vue&type=script&lang=js&"
import style0 from "./otherGoodsInfoModules.vue?vue&type=style&index=0&id=fa883d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa883d06",
  null
  
)

export default component.exports